import { isBoolean } from 'lodash/fp';

import {
	DEVICE_AUTHORIZATIONS_LISTEN,
	RETRIEVE_INFO,
	SET_IS_DARK_MODE,
	SET_LAUNCH_SOURCE,
	SET_STATUS_BAR_COLOR,
	UPDATE_INFO,
} from './actions';
import { CLIENT_PLATFORM, SCREEN_ORIENTATION } from './constants';
import { ClientInfoState } from './types';
import { CLEAR_STORE } from '../shared/actions';

const initialState = {
	deviceUuid: undefined,
	isAppFirstRun: false,
	isDarkMode: false,
	isDeviceAuthorizationsEnabled: true,
	isFaceIdAvailable: false,
	isFingerprintDeclined: false,
	isFingerprintSet: false,
	isWatchEnabled: false,
	isInitialized: false,
	isLoading: true,
	isNativeBackEnabled: false,
	isPinSet: false,
	isPrimaryDevice: false,
	isPushNotificationAvailable: undefined,
	isPushNotificationEnabled: false,
	isPushNotificationOptIn: false,
	isPushNotificationPermitted: false,
	isPushNotificationPrompted: false,
	isTouchIdAvailable: false,
	platform: CLIENT_PLATFORM.WEB,
	screenOrientation: SCREEN_ORIENTATION.PORTRAIT,
	screenSize: '',
	useLightColorToneStatusBar: true,
	launchSource: undefined,
};

// TODO: Add types for action
const reducer = (state: ClientInfoState = initialState, action): ClientInfoState => {
	switch (action.type) {
		case DEVICE_AUTHORIZATIONS_LISTEN:
			return { ...state, isDeviceAuthorizationsEnabled: action.payload.enable };
		case RETRIEVE_INFO:
			return { ...state, isLoading: true };
		case SET_IS_DARK_MODE: {
			return { ...state, isDarkMode: action.payload.isDarkMode };
		}
		case SET_STATUS_BAR_COLOR: {
			const { useLightColorTone } = action.payload;
			// only boolean values are handled, passing other values (like null or undefined) is ignored
			// in reducer, but handled in middleware. This allows to update status bar color when dark
			// mode is en/dis-abled while the preferred mode for non-darkMode is kept in store
			return isBoolean(useLightColorTone)
				? { ...state, useLightColorToneStatusBar: useLightColorTone }
				: state;
		}
		case UPDATE_INFO:
			return { ...state, ...action.payload, isLoading: false };
		case SET_LAUNCH_SOURCE:
			if (state.launchSource) {
				throw new Error('Launch source is already set and cannot be changed');
			}

			return { ...state, launchSource: action.payload.launchSource };
		case CLEAR_STORE:
			return initialState;
		default:
			return state;
	}
};

export default reducer;
